export const translations = {
  es: {
    brand: {
      name: 'Lipo Laser',
      city: 'Beverly Hills',
      tagline: 'Contorno corporal mínimamente invasivo en Beverly Hills, CA.',
    },
    nav: {
      benefits: 'Por Qué Elegirnos',
      process: 'El Proceso',
      areas: 'Zonas',
      doctor: 'El Doctor',
      testimonials: 'Resultados',
      faq: 'Preguntas',
      contact: 'Reserva Gratis',
      cta: 'Reserva Tu Valoración GRATIS',
    },
    hero: {
      badge: 'Beverly Hills, CA · +5,000 Procedimientos',
      eyebrow: '🔥 MÁS DE 5,000 PROCEDIMIENTOS EXITOSOS',
      headline: '¿Cansada de que el Gimnasio NO Elimine Esa Grasa Localizada?',
      sublineEmotional:
        'Miles de mujeres en Los Angeles ya han transformado su figura.',
      highlight: 'sin cirugía mayor',
      subheadline:
        'Procedimientos mínimamente invasivos guiados por un cirujano plástico certificado. Desde $89/mes con financiamiento aprobado. En Beverly Hills, CA.',
      cta: 'Reserva Tu Valoración GRATIS',
      ctaSecondary: 'Ver Resultados Primero',
      trust1: 'Cirujano Plástico Certificado',
      trust2: 'Tecnología Aprobada por FDA',
      trust3: 'Resultados Naturales',
      socialProof: 'María de Los Angeles reservó su valoración hace 3 min',
      rating: '98% Satisfacción · 4.9/5',
      doctorCardCredentials: 'Beverly Hills, CA · Board Certified',
      doctorCardTagline:
        'Precisión de cirugía plástica. +5,000 procedimientos. Resultados naturales.',
    },
    benefits: {
      eyebrow: 'POR QUÉ ELEGIRNOS',
      heading: '¿Por Qué Elegir Lipo Laser Beverly Hills?',
      subheading:
        'La única clínica mínimamente invasiva en Beverly Hills dirigida por un cirujano plástico certificado.',
      items: [
        {
          title: 'Tecnología Láser Avanzada',
          desc: 'Sin cirugía mayor. Láser de precisión que derrite la grasa antes de extraerla suavemente.',
          key: 'natural',
        },
        {
          title: 'Recuperación Rápida',
          desc: 'Vuelve a tu rutina en 2-5 días, no semanas. Sin drenajes dolorosos.',
          key: 'recovery',
        },
        {
          title: 'Atención Especializada',
          desc: 'Equipo con miles de horas específicas en contorno corporal mínimamente invasivo. No somos una clínica generalista.',
          key: 'safe',
        },
        {
          title: 'Resultados Naturales',
          desc: 'Esculpimos respetando tus curvas naturales. Nadie notará que te hiciste un procedimiento.',
          key: 'inches',
        },
        {
          title: 'Financiamiento Flexible',
          desc: 'Desde $89/mes con CareCredit, Affirm, Alphaeon y Cherry. Pre-aprobación sin afectar tu crédito.',
          key: 'financing',
        },
        {
          title: 'Tu Piel Permanece Intacta',
          desc: 'Técnicas mínimamente invasivas que respetan la integridad de tu piel. Sin cicatrices visibles.',
          key: 'smooth',
        },
      ],
    },
    process: {
      eyebrow: 'EL PROCESO',
      heading: 'Tu Transformación en 4 Pasos Simples',
      subheading:
        'Un camino claro, sin sorpresas, diseñado para que avances con confianza.',
      steps: [
        {
          number: '01',
          title: 'Valoración GRATIS',
          desc: 'Completa el formulario y te contactamos para agendar tu valoración personalizada — 100% gratuita, sin compromiso.',
        },
        {
          number: '02',
          title: 'Plan Personalizado',
          desc: 'Evaluación médica completa. Recibes un plan específico para tus zonas y pre-aprobación de financiamiento.',
        },
        {
          number: '03',
          title: 'Tu Procedimiento',
          desc: 'Procedimiento mínimamente invasivo bajo anestesia local en nuestra clínica de Beverly Hills. Sin cirugía mayor.',
        },
        {
          number: '04',
          title: 'Recuperación Rápida',
          desc: 'Vuelve a trabajar en 2-5 días. Seguimiento continuo y resultados visibles desde la primera sesión.',
        },
      ],
    },
    areas: {
      eyebrow: 'ZONAS',
      heading: 'Esculpe la Silueta que Mereces',
      subheading:
        'Procedimientos mínimamente invasivos por zona, adaptados a tu cuerpo.',
      items: [
        { name: 'Espalda', key: 'back' },
        { name: 'Abdomen', key: 'abdomen' },
        { name: 'Flancos', key: 'flanks' },
        { name: 'Piernas', key: 'legs' },
        { name: 'Glúteos', key: 'glutes' },
        { name: 'Papada', key: 'chin' },
        { name: 'Brazos', key: 'arms' },
        { name: 'Pechos', key: 'chest' },
      ],
    },
    doctor: {
      eyebrow: 'EL DOCTOR',
      heading: 'Dr. Naveed N. Nosrati, MD — Cirugía Plástica',
      subheading:
        'Cirujano plástico certificado especializado en contorno corporal mínimamente invasivo. La precisión de la cirugía plástica con la velocidad de recuperación de los procedimientos no invasivos.',
      pillars: [
        {
          title: 'Cirujano Plástico Certificado',
          body: 'La única clínica mínimamente invasiva en Beverly Hills dirigida por un cirujano plástico certificado. Precisión quirúrgica — sin la recuperación quirúrgica.',
        },
        {
          title: 'Tecnología Láser Aprobada por la FDA',
          body: 'Equipos láser de última generación aprobados por la FDA para reducción de grasa localizada. Sin cortes mayores, sin drenajes dolorosos, sin recuperación prolongada.',
        },
        {
          title: 'Cumplimiento Médico California',
          body: 'Cada procedimiento se realiza bajo estándares médicos rigurosos y en total cumplimiento con las regulaciones de salud del estado de California. Evaluación médica completa antes de cualquier procedimiento.',
        },
      ],
      badges: [
        { value: '+5,000', label: 'Procedimientos' },
        { value: '+15', label: 'Años de Experiencia' },
        { value: 'Board Certified', label: 'Cirugía Plástica' },
        { value: 'Beverly Hills, CA', label: 'Nuestra Clínica' },
      ],
    },
    authority: {
      eyebrow: 'RESULTADOS QUE HABLAN',
      heading: 'Destino #1 de Contorno Corporal en Beverly Hills',
      stats: [
        { value: '+5,000', label: 'Procedimientos' },
        { value: '+15', label: 'Años de Experiencia' },
        { value: 'Beverly Hills CA', label: 'Nuestra Clínica' },
        { value: '98%', label: 'Satisfacción' },
      ],
      pillars: [
        {
          title: 'Atención Bilingüe',
          desc: 'Te acompañamos en español o inglés. Antes, durante y después de tu procedimiento.',
        },
        {
          title: 'Financiamiento Desde $89/Mes',
          desc: 'Trabajamos con CareCredit, Affirm, Alphaeon y Cherry. Pre-aprobación sin impacto en tu crédito.',
        },
        {
          title: 'Recuperación Rápida',
          desc: 'Vuelve a trabajar en 2-5 días. Sin drenajes dolorosos, sin recuperación prolongada.',
        },
        {
          title: 'Privacidad Absoluta',
          desc: 'Una clínica privada en Beverly Hills. Discreción total en cada visita.',
        },
      ],
      financingTitle: 'Financiamiento Disponible Desde $89/Mes',
      financing: ['CareCredit', 'Affirm', 'Alphaeon', 'Cherry'],
      cherryTitle: 'Pre-califica en 60 Segundos',
      cherrySubtitle: 'Sin afectar tu crédito · Aprobación instantánea',
      cherryCta: 'Pre-calificar Ahora con Cherry',
    },
    cherry: {
      eyebrow: 'CALCULA TU PAGO',
      heading: '¿Cuánto pagarías al mes?',
      subheading:
        'Pre-calcula tu pago mensual en segundos con nuestro partner Cherry. Sin afectar tu crédito.',
      disclaimer:
        'La pre-calificación no garantiza la aprobación final. Sujeto a los términos y condiciones de Cherry.',
      floaterEyebrow: 'FINANCIAMIENTO',
      floaterTitle: 'Desde $89/mes',
      floaterCta: 'Calcula tu pago',
      floaterAriaLabel: 'Calcula tu pago con Cherry',
    },
    testimonials: {
      eyebrow: 'TRANSFORMACIONES',
      heading: 'Resultados Reales. Transformaciones Reales.',
      subheading: '4.9/5 Promedio · 98% Satisfacción',
      before: 'Antes',
      after: 'Después',
      session: '1 Sesión',
      bannerTag: 'Lipo 360',
      bannerQuote:
        'Volví a sentirme segura de mi cuerpo. Fue la mejor decisión que tomé por mí.',
      bannerAttribution: '— María G., Los Angeles, CA · Lipo 360',
      categories: {
        all: 'Todas',
        abdomen: 'Abdomen',
        flanks: 'Flancos',
        arms: 'Brazos',
        chin: 'Papada',
      },
      privacyNote:
        'Resultados individuales pueden variar. Imágenes utilizadas con consentimiento expreso de cada paciente.',
    },
    faq: {
      eyebrow: 'PREGUNTAS FRECUENTES',
      heading: 'Lo que querías saber, respondido con claridad.',
      subheading:
        'Y si tu pregunta no está aquí, la responderemos en tu valoración gratuita.',
      items: [
        {
          q: '¿Duele el procedimiento?',
          a: 'El procedimiento se realiza bajo anestesia local con sedación opcional. La mayoría de pacientes reportan molestia mínima durante los primeros 2-3 días, controlada con medicación oral. Las técnicas mínimamente invasivas han reducido drásticamente el dolor comparado con la liposucción tradicional.',
        },
        {
          q: '¿Cuánto cuesta?',
          a: 'Los precios varían según las zonas tratadas y la complejidad de tu caso. Ofrecemos planes de financiamiento desde $89/mes con CareCredit, Affirm, Alphaeon y Cherry. La valoración gratuita te da un precio exacto adaptado a ti.',
        },
        {
          q: '¿Es seguro?',
          a: 'Todos nuestros procedimientos usan tecnología aprobada por la FDA y se realizan bajo estándares médicos rigurosos en cumplimiento con las regulaciones de California. Cada paciente recibe una evaluación médica completa antes de cualquier procedimiento.',
        },
        {
          q: '¿Cuánto dura la recuperación?',
          a: 'La mayoría de pacientes vuelven a trabajos de oficina en 2-5 días. La actividad física intensa puede reanudarse a las 4-6 semanas, según el caso y la recomendación clínica.',
        },
        {
          q: '¿Y si no califico para financiamiento?',
          a: 'Trabajamos con 4 partners de financiamiento distintos (CareCredit, Affirm, Alphaeon, Cherry) precisamente para maximizar tus opciones de aprobación. Si un partner no te aprueba, otro suele hacerlo. Además, consultarlo no afecta tu crédito.',
        },
        {
          q: '¿Son permanentes los resultados?',
          a: 'Las células grasas eliminadas no regresan. Sin embargo, mantener un estilo de vida saludable es clave para preservar los resultados a largo plazo. Los resultados individuales varían según cada paciente.',
        },
      ],
    },
    location: {
      eyebrow: 'NUESTRA CLÍNICA',
      heading: 'Beverly Hills, California',
      subheading: 'En el corazón de Beverly Hills.',
      address: '6404 Wilshire Blvd, Suite 610, Los Angeles, CA 90048',
      addressLabel: 'DIRECCIÓN',
      phoneLabel: 'TELÉFONO',
      emailLabel: 'EMAIL',
      hoursLabel: 'HORARIO',
      hours: 'Lun–Vie 9AM–6PM · Sáb 9AM–3PM · Dom Cerrado',
    },
    contact: {
      eyebrow: 'RESERVA AHORA',
      heading: 'Verifica Disponibilidad en Beverly Hills',
      subhead:
        'Completa el formulario para asegurar tu cupo en nuestra clínica de Beverly Hills. Valoración 100% gratuita y sin compromiso.',
      urgency:
        'Los cupos para esta semana se están llenando rápido. No esperes más — tu transformación empieza HOY.',
      benefits: [
        'Valoración médica 100% GRATUITA',
        'Pre-aprobación de financiamiento desde $89/mes',
        'Plan personalizado adaptado a tu cuerpo',
        'Respuesta dentro de 24 horas',
      ],
      trust: {
        secure: 'Confidencial',
        response: 'Respuesta 24h',
        bilingual: 'Bilingüe',
      },
      financingNote:
        'Financiamiento desde $89/mes con CareCredit, Affirm, Alphaeon y Cherry. Pre-aprobación en minutos. Sin impacto en tu crédito.',
    },
    stickyCta: {
      text: 'Valoración GRATIS',
      button: 'Reservar',
    },
    footer: {
      tagline: 'Contorno corporal mínimamente invasivo en Beverly Hills, CA.',
      quickLinks: 'Navegación',
      legal: 'Legal',
      rights:
        '© 2026 Lipo Laser Beverly Hills. Todos los derechos reservados.',
      disclaimer:
        'Los resultados individuales pueden variar. Las imágenes son representativas. Se requiere evaluación médica con el Dr. Naveed N. Nosrati MD antes de cualquier procedimiento.',
      links: {
        privacy: 'Privacidad',
        terms: 'Términos',
        cookies: 'Cookies',
        patient: 'Derechos del Paciente',
      },
    },
  },
  en: {
    brand: {
      name: 'Lipo Laser',
      city: 'Beverly Hills',
      tagline: 'Minimally invasive body contouring in Beverly Hills, CA.',
    },
    nav: {
      benefits: 'Why Choose Us',
      process: 'The Process',
      areas: 'Areas',
      doctor: 'The Doctor',
      testimonials: 'Results',
      faq: 'Questions',
      contact: 'Book Free',
      cta: 'Book Your FREE Evaluation',
    },
    hero: {
      badge: 'Beverly Hills, CA · +5,000 Procedures',
      eyebrow: '🔥 OVER 5,000 SUCCESSFUL PROCEDURES',
      headline: 'Tired of the Gym NOT Eliminating That Stubborn Fat?',
      sublineEmotional:
        'Thousands of women in Los Angeles have already transformed their figures.',
      highlight: 'no major surgery',
      subheadline:
        'Minimally invasive procedures guided by a board-certified plastic surgeon. Starting at just $89/mo. In Beverly Hills, CA.',
      cta: 'Book Your FREE Evaluation',
      ctaSecondary: 'See Results First',
      trust1: 'Board-Certified Plastic Surgeon',
      trust2: 'FDA-Approved Technology',
      trust3: 'Natural Results',
      socialProof: 'Maria from Los Angeles booked her evaluation 3 min ago',
      rating: '98% Satisfaction · 4.9/5',
      doctorCardCredentials: 'Beverly Hills, CA · Board Certified',
      doctorCardTagline:
        'Plastic surgery precision. 5,000+ procedures. Natural results.',
    },
    benefits: {
      eyebrow: 'WHY CHOOSE US',
      heading: 'Why Choose Lipo Laser Beverly Hills?',
      subheading:
        'The only minimally invasive clinic in Beverly Hills led by a board-certified plastic surgeon.',
      items: [
        {
          title: 'Advanced Laser Technology',
          desc: 'No major surgery. Precision laser melts the fat before gently extracting it.',
          key: 'natural',
        },
        {
          title: 'Rapid Recovery',
          desc: 'Return to your routine in 2-5 days, not weeks. No painful drains.',
          key: 'recovery',
        },
        {
          title: 'Specialized Care',
          desc: 'A team with thousands of specific hours in minimally invasive body contouring. We are not a generalist clinic.',
          key: 'safe',
        },
        {
          title: 'Natural Results',
          desc: 'We sculpt while respecting your natural curves. No one will notice you had a procedure.',
          key: 'inches',
        },
        {
          title: 'Flexible Financing',
          desc: 'From $89/mo with CareCredit, Affirm, Alphaeon, and Cherry. Pre-approval with no impact on your credit.',
          key: 'financing',
        },
        {
          title: 'Your Skin Stays Intact',
          desc: 'Minimally invasive techniques that respect the integrity of your skin. No visible scarring.',
          key: 'smooth',
        },
      ],
    },
    process: {
      eyebrow: 'THE PROCESS',
      heading: 'Your Transformation in 4 Simple Steps',
      subheading:
        'A clear path, no surprises, designed for you to move forward with confidence.',
      steps: [
        {
          number: '01',
          title: 'FREE Evaluation',
          desc: 'Complete the form and we contact you to schedule your personalized evaluation — 100% free, no obligation.',
        },
        {
          number: '02',
          title: 'Personalized Plan',
          desc: 'Complete medical evaluation. You receive a plan specific to your areas and financing pre-approval.',
        },
        {
          number: '03',
          title: 'Your Procedure',
          desc: 'Minimally invasive procedure under local anesthesia at our Beverly Hills clinic. No major surgery.',
        },
        {
          number: '04',
          title: 'Rapid Recovery',
          desc: 'Return to work in 2-5 days. Continuous follow-up and visible results from the first session.',
        },
      ],
    },
    areas: {
      eyebrow: 'AREAS',
      heading: 'Sculpt the Silhouette You Deserve',
      subheading:
        'Minimally invasive procedures by area, tailored to your body.',
      items: [
        { name: 'Back', key: 'back' },
        { name: 'Abdomen', key: 'abdomen' },
        { name: 'Flanks', key: 'flanks' },
        { name: 'Legs', key: 'legs' },
        { name: 'Glutes', key: 'glutes' },
        { name: 'Chin', key: 'chin' },
        { name: 'Arms', key: 'arms' },
        { name: 'Chest', key: 'chest' },
      ],
    },
    doctor: {
      eyebrow: 'THE DOCTOR',
      heading: 'Dr. Naveed N. Nosrati, MD — Plastic Surgery',
      subheading:
        'Board-certified plastic surgeon specialized in minimally invasive body contouring. The precision of plastic surgery with the recovery speed of non-invasive procedures.',
      pillars: [
        {
          title: 'Board-Certified Plastic Surgeon',
          body: 'The only minimally invasive clinic in Beverly Hills led by a board-certified plastic surgeon. Surgical precision — without the surgical recovery.',
        },
        {
          title: 'FDA-Approved Laser Technology',
          body: 'State-of-the-art FDA-approved laser equipment for localized fat reduction. No major incisions, no painful drains, no extended recovery.',
        },
        {
          title: 'California Medical Compliance',
          body: 'Every procedure performed under rigorous medical standards in full compliance with California health regulations. Complete medical evaluation before any procedure.',
        },
      ],
      badges: [
        { value: '+5,000', label: 'Procedures' },
        { value: '+15', label: 'Years Experience' },
        { value: 'Board Certified', label: 'Plastic Surgery' },
        { value: 'Beverly Hills, CA', label: 'Our Clinic' },
      ],
    },
    authority: {
      eyebrow: 'RESULTS THAT SPEAK',
      heading: '#1 Body Contouring Destination in Beverly Hills',
      stats: [
        { value: '+5,000', label: 'Procedures' },
        { value: '+15', label: 'Years of Experience' },
        { value: 'Beverly Hills CA', label: 'Our Clinic' },
        { value: '98%', label: 'Satisfaction' },
      ],
      pillars: [
        {
          title: 'Bilingual Care',
          desc: 'We accompany you in Spanish or English. Before, during, and after your procedure.',
        },
        {
          title: 'Financing From $89/Mo',
          desc: 'We partner with CareCredit, Affirm, Alphaeon, and Cherry. Pre-approval with no impact on your credit.',
        },
        {
          title: 'Rapid Recovery',
          desc: 'Return to work in 2-5 days. No painful drains, no extended recovery.',
        },
        {
          title: 'Absolute Privacy',
          desc: 'A private clinic in Beverly Hills. Complete discretion on every visit.',
        },
      ],
      financingTitle: 'Financing Available From $89/Mo',
      financing: ['CareCredit', 'Affirm', 'Alphaeon', 'Cherry'],
      cherryTitle: 'Pre-qualify in 60 Seconds',
      cherrySubtitle: 'No impact on your credit · Instant approval',
      cherryCta: 'Pre-qualify Now with Cherry',
    },
    cherry: {
      eyebrow: 'CALCULATE YOUR PAYMENT',
      heading: 'What would you pay monthly?',
      subheading:
        'Pre-calculate your monthly payment in seconds with our partner Cherry. No impact on your credit.',
      disclaimer:
        'Pre-qualification does not guarantee final approval. Subject to Cherry terms and conditions.',
      floaterEyebrow: 'FINANCING',
      floaterTitle: 'From $89/mo',
      floaterCta: 'Calculate your payment',
      floaterAriaLabel: 'Calculate your payment with Cherry',
    },
    testimonials: {
      eyebrow: 'TRANSFORMATIONS',
      heading: 'Real Results. Real Transformations.',
      subheading: '4.9/5 Average · 98% Satisfaction',
      before: 'Before',
      after: 'After',
      session: '1 Session',
      bannerTag: 'Lipo 360',
      bannerQuote:
        'I finally feel confident in my body again. Best decision I ever made for myself.',
      bannerAttribution: '— María G., Los Angeles, CA · Lipo 360',
      categories: {
        all: 'All',
        abdomen: 'Abdomen',
        flanks: 'Flanks',
        arms: 'Arms',
        chin: 'Chin',
      },
      privacyNote:
        'Individual results may vary. Images shared with express consent from each patient.',
    },
    faq: {
      eyebrow: 'FREQUENT QUESTIONS',
      heading: 'What you wanted to ask, answered with clarity.',
      subheading:
        'And if your question is not here, we will answer it in your free evaluation.',
      items: [
        {
          q: 'Does the procedure hurt?',
          a: 'The procedure is performed under local anesthesia with optional sedation. Most patients report minimal discomfort during the first 2-3 days, controlled with oral medication. Minimally invasive techniques have drastically reduced pain compared to traditional liposuction.',
        },
        {
          q: 'How much does it cost?',
          a: 'Pricing varies based on the areas treated and the complexity of your case. We offer financing plans from $89/mo with CareCredit, Affirm, Alphaeon, and Cherry. The free evaluation gives you an exact price adapted to you.',
        },
        {
          q: 'Is it safe?',
          a: 'All of our procedures use FDA-approved technology and are performed under rigorous medical standards in compliance with California regulations. Every patient receives a complete medical evaluation before any procedure.',
        },
        {
          q: 'How long is recovery?',
          a: 'Most patients return to office work in 2-5 days. Intense physical activity can be resumed at 4-6 weeks, depending on the case and the clinical recommendation.',
        },
        {
          q: "What if I don't qualify for financing?",
          a: "We work with 4 different financing partners (CareCredit, Affirm, Alphaeon, Cherry) specifically to maximize your approval options. If one partner doesn't approve you, another usually will. Plus, checking does not affect your credit.",
        },
        {
          q: 'Are results permanent?',
          a: 'The fat cells removed do not return. However, maintaining a healthy lifestyle is key to preserving long-term results. Individual results vary by patient.',
        },
      ],
    },
    location: {
      eyebrow: 'OUR CLINIC',
      heading: 'Beverly Hills, California',
      subheading: 'In the heart of Beverly Hills.',
      address: '6404 Wilshire Blvd, Suite 610, Los Angeles, CA 90048',
      addressLabel: 'ADDRESS',
      phoneLabel: 'PHONE',
      emailLabel: 'EMAIL',
      hoursLabel: 'HOURS',
      hours: 'Mon–Fri 9AM–6PM · Sat 9AM–3PM · Sun Closed',
    },
    contact: {
      eyebrow: 'BOOK NOW',
      heading: 'Check Availability in Beverly Hills',
      subhead:
        'Complete the form to secure your spot at our Beverly Hills clinic. 100% free evaluation with no obligation.',
      urgency:
        "Appointments for this week are filling up fast. Don't wait any longer — your transformation starts TODAY.",
      benefits: [
        '100% FREE medical evaluation',
        'Financing pre-approval from $89/mo',
        'Personalized plan tailored to your body',
        'Response within 24 hours',
      ],
      trust: {
        secure: 'Confidential',
        response: '24h Response',
        bilingual: 'Bilingual',
      },
      financingNote:
        'Financing from $89/mo with CareCredit, Affirm, Alphaeon, and Cherry. Pre-approval in minutes. No impact on your credit.',
    },
    stickyCta: {
      text: 'FREE Evaluation',
      button: 'Book',
    },
    footer: {
      tagline: 'Minimally invasive body contouring in Beverly Hills, CA.',
      quickLinks: 'Navigation',
      legal: 'Legal',
      rights: '© 2026 Lipo Laser Beverly Hills. All rights reserved.',
      disclaimer:
        'Individual results may vary. Images are representative. Medical evaluation with Dr. Naveed N. Nosrati MD required before any procedure.',
      links: {
        privacy: 'Privacy',
        terms: 'Terms',
        cookies: 'Cookies',
        patient: 'Patient Rights',
      },
    },
  },
}

export type Language = 'es' | 'en'
